'use strict';

var React = require('react');
var component$1 = require('../../Tooltip/component.js');
var index = require('../../Flex/index.js');
var component = require('../../Icon/component.js');
var styles = require('./styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const FormLabel = React.forwardRef(({ required, text, info, infoIcon = 'info-circle-filled', ...props }, ref) => {
    const [tooltipTarget, setTooltipTarget] = React.useState(null);
    return (React__default.default.createElement(styles.Styled.Label, { ...props, ref: ref },
        React__default.default.createElement(index.Flex.Row, { space: "xs" },
            React__default.default.createElement("div", null, text),
            required && React__default.default.createElement(styles.Styled.Required, null, '*'),
            info && React__default.default.createElement(component.Icon, { name: infoIcon, ref: setTooltipTarget })),
        info && (React__default.default.createElement(component$1.Tooltip, { placement: "top", target: tooltipTarget }, info))));
});

exports.FormLabel = FormLabel;
//# sourceMappingURL=component.js.map
